module.exports = __webpack_public_path__ + "img/gupiao.32721724.png";